(function () {
    'use strict';

    angular
        .module('adm')
        .controller('AdmJobDescriptionCreateController', AdmJobDescriptionCreateController);

    AdmJobDescriptionCreateController.$inject = ['AdmService','$state'];

    function AdmJobDescriptionCreateController(AdmService, $state) {

        var vm                              = this;
        vm.activate                         = activate;
        vm.storeJobDescription              = storeJobDescription;
        vm.getJobDescriptionsForSelect      = getJobDescriptionsForSelect;
        vm.create                           = [];
        vm.departmentSelected               = '';
        vm.getDepartmentsForSelect          = getDepartmentsForSelect;
        vm.positionSelected                 = '';
        vm.jobDescriptionsSelected          = [];
        vm.responsibilitiesFields           = [{value : ''}];
        vm.addResponsibilitiesField         = addResponsibilitiesField;
        vm.removeResponsibilitiesField      = removeResponsibilitiesField;
        vm.description                      = '';
        vm.admUserSelected                  = [];
        vm.getAdmUsersStaff                 = getAdmUsersStaff;
        vm.cancel                           = cancel;

        function storeJobDescription()
        {
            vm.query = {};
            vm.query['department']          = vm.departmentSelected;
            vm.query['adm_user_id']         = vm.admUserSelected;
            vm.query['position']            = vm.positionSelected;
            vm.query['description']         = vm.description;
            vm.query['reportTo']            = vm.jobDescriptionsSelected;
            vm.query['responsibilities']    = vm.responsibilitiesFields;
            AdmService.storeJobDescription(vm.query).then(function(response){
                $state.go('root.adm.jobDescription.list');
            });
        }

        function getJobDescriptionsForSelect()
        {
            AdmService.getJobDescriptionsForSelect().then(function(response){
                vm.queryFlag        = true;
                vm.jobDescriptions  = response.data;
                vm.positions        = response.data;
            }).catch(function(err) {

            });
        }

        function getDepartmentsForSelect()
        {
            AdmService.getDepartmentsForSelect(vm.query).then(function(response){
                vm.queryFlag    = true;
                vm.departments  = response.data;
                console.log(vm.departments);
            }).catch(function(err) {

            });
        }

        function addResponsibilitiesField()
        {
            vm.responsibilitiesFields.push({value : ''});
        }

        function removeResponsibilitiesField(field)
        {
            vm.responsibilitiesFields.splice(vm.responsibilitiesFields.indexOf(field), 1);
        }

        function getAdmUsersStaff()
        {
            AdmService.getAdmUsersStaff(vm.query).then(function(response){
                vm.admUsers  = response.data;
            }).catch(function(err) {

            });
        }

        function cancel(){
            $state.go('root.adm.jobDescription.list');
        }

        function activate() {
            vm.getDepartmentsForSelect();
            vm.getJobDescriptionsForSelect();
            vm.getAdmUsersStaff();
        }
        vm.activate();
    }

})();